import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb, MasterDetailLayout, NeoSideMenu, NeoSearch, DataTable } from "../../../components/Common";
import { Card, CardHeader, CardBody, Badge } from "reactstrap";
import { useActivityMembers } from "./hooks/useActivityMembers";
import { getMembersColumns } from "../../Member/constants";

const ActivityMembersPage = () => {
    const navigate = useNavigate();
    const [searchQuery, setSearchQuery] = useState("");
    const { 
        activities, 
        loading, 
        selectedActivity, 
        selectedMembers, 
        loadingMembers, 
        actions 
    } = useActivityMembers();

    // Filtrar atividades baseado na pesquisa local
    const filteredActivities = (activities || []).filter((act) =>
        act.name?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Mapear atividades para itens do NeoSideMenu
    const sideMenuItems = filteredActivities.map((act) => ({
        id: act.id,
        label: act.name,
        description: `Métricas pedagógicas`,
        icon: "mdi-format-list-bulleted",
        badge: act.memberCount || 0,
        badgeVariant: "accent"
    }));

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="Alunos por Atividade" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="activities-container mt-3">
                <MasterDetailLayout
                    master={
                        <NeoSideMenu
                            title="Atividades"
                            subtitle="Métricas por Atividade"
                            icon="mdi-format-list-bulleted"
                            loading={loading}
                            items={sideMenuItems}
                            activeId={selectedActivity?.id}
                            onSelect={(id) => {
                                const activity = activities.find((a) => a.id === id);
                                if (activity) actions.handleFetchMembersForActivity(activity);
                            }}
                            searchComponent={
                                <NeoSearch
                                    size="sm"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    placeholder="Buscar atividade..."
                                />
                            }
                        />
                    }
                    detail={
                        selectedActivity ? (
                            <Card className="border-0 shadow-sm">
                                <CardHeader className="bg-white border-bottom py-3 px-4">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h6 className="mb-0 fw-bold text-dark">{selectedActivity.name}</h6>
                                        <Badge color="primary" className="rounded px-2 py-1">
                                            {selectedActivity.memberCount} matriculados
                                        </Badge>
                                    </div>
                                </CardHeader>
                                <CardBody className="p-0">
                                    <div style={{ maxHeight: "calc(100vh - 250px)", overflowY: "auto" }}>
                                        <DataTable
                                            columns={getMembersColumns(navigate)}
                                            data={selectedMembers}
                                            isLoading={loadingMembers}
                                            emptyMessage="Nenhum aluno ativo nesta atividade."
                                            noCard={true}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        ) : (
                            <Card className="border-0 shadow-sm d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                <div className="text-center text-muted">
                                    <i className="mdi mdi-arrow-left mt-0 d-block font-size-24 text-primary"></i>
                                    <h5 className="mt-3">Selecione uma atividade</h5>
                                    <p>Clique em uma atividade na lista lateral para ver os alunos matriculados.</p>
                                </div>
                            </Card>
                        )
                    }
                />
            </div>
        </React.Fragment>
    );
};

export default ActivityMembersPage;
